// Configuración de Estados y Roles de Empresa con descripciones contextuales

export const STATUS_CONFIG = {
  'Prospecto': {
    label: 'Prospecto',
    description: 'Empresa detectada con potencial, pero sin relación real todavía.',
    color: 'bg-yellow-100 text-yellow-800 border-yellow-300'
  },
  'En relación': {
    label: 'En relación',
    description: 'Existe conversación activa: llamadas, reuniones o intercambio de información para generar oportunidad.',
    color: 'bg-blue-100 text-blue-800 border-blue-300'
  },
  'Cliente': {
    label: 'Cliente',
    description: 'Ya nos ha contratado al menos una vez.',
    color: 'bg-green-100 text-green-800 border-green-300'
  },
  'No estratégica': {
    label: 'No estratégica',
    description: 'No es prioritaria actualmente; no dedicar esfuerzo salvo oportunidad clara.',
    color: 'bg-gray-100 text-gray-600 border-gray-300'
  }
};

export const ROL_CONFIG = {
  'Cliente': {
    label: 'Cliente',
    description: 'Puede contratarnos directamente; fuente directa de ingresos.',
    color: 'bg-emerald-100 text-emerald-800 border-emerald-300'
  },
  'Partner': {
    label: 'Partner',
    description: 'Colabora con nosotros para conseguir proyectos.',
    color: 'bg-purple-100 text-purple-800 border-purple-300'
  },
  'Competidor': {
    label: 'Competidor',
    description: 'Compite con nosotros por los mismos contratos.',
    color: 'bg-red-100 text-red-800 border-red-300'
  },
  'Mixto': {
    label: 'Mixto',
    description: 'A veces colabora y a veces compite según proyecto.',
    color: 'bg-orange-100 text-orange-800 border-orange-300'
  }
};

export const STATUS_OPTIONS = Object.keys(STATUS_CONFIG);
export const ROL_OPTIONS = Object.keys(ROL_CONFIG);

// Helper para obtener el color del estado
export const getStatusColor = (status) => {
  return STATUS_CONFIG[status]?.color || 'bg-gray-100 text-gray-600 border-gray-300';
};

// Helper para obtener el color del rol
export const getRolColor = (rol) => {
  return ROL_CONFIG[rol]?.color || 'bg-gray-100 text-gray-600 border-gray-300';
};

// Helper para obtener la descripción del estado
export const getStatusDescription = (status) => {
  return STATUS_CONFIG[status]?.description || '';
};

// Helper para obtener la descripción del rol
export const getRolDescription = (rol) => {
  return ROL_CONFIG[rol]?.description || '';
};
